import { Game } from './core/Game';

// 等待 DOM 加载完成后初始化游戏
window.addEventListener('DOMContentLoaded', () => {
    const game = new Game();
    game.start().catch(error => {
        console.error('游戏启动失败:', error);
        const storyElement = document.getElementById('story-text');
        if (storyElement) {
            storyElement.innerHTML = '游戏启动失败，请刷新页面重试...';
        }
    });
});

// 添加复制功能
document.querySelector('.copy-id')?.addEventListener('click', async function(this: HTMLElement) {
    const id = this.getAttribute('data-id');
    if (id) {
        try {
            await navigator.clipboard.writeText(id);
            const tooltip = document.querySelector('.copy-tooltip');
            if (tooltip) {
                tooltip.textContent = '已复制！';
                tooltip.classList.add('show');
                setTimeout(() => {
                    tooltip.classList.remove('show');
                    tooltip.textContent = '点击复制';
                }, 2000);
            }
        } catch (err) {
            console.error('复制失败:', err);
        }
    }
}); 